import React from 'react';
import { Modal } from 'components';
import { CloseIcon } from 'assets/icons';

interface Props {
  visible: boolean;
  currentMembershipName?: string;
  newMembershipName?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Modal de aviso de riesgo mostrado antes de procesar un cambio de membresía.
 *
 * Se muestra cuando un usuario que YA tiene una membresía activa selecciona
 * "Adquirir" sobre una membresía distinta. Informa de forma explícita que:
 *  - La membresía actual será cancelada de inmediato.
 *  - La nueva membresía se cobrará de forma completa.
 *  - No se prorratea el tiempo restante de la membresía actual.
 *
 * El usuario debe confirmar explícitamente (botón "Sí, cambiar membresía")
 * para que el flujo continúe hacia la selección de tiempo/pago. Si cancela,
 * se regresa a la pantalla de selección de membresías sin aplicar cambios.
 */
const MembershipChangeWarningModal = (props: Props) => {
  return (
    <Modal
      className='modal-membership-change-warning'
      visible={props.visible}
      hideHeader={true}
      onClose={props.onCancel}
    >
      <div id='membership-change-warning'>
        <button
          type='button'
          className='btn-close-warning'
          onClick={props.onCancel}
          aria-label='Cerrar'
        >
          <img src={CloseIcon} />
        </button>

        <div className='icon-warning'>&#9888;</div>

        <p className='title'>Vas a cambiar de membresía</p>

        {props.currentMembershipName && (
          <p className='subtitle'>
            Estás a punto de cambiar tu membresía actual
            {' "'}
            <strong>{props.currentMembershipName}</strong>
            {'" '}
            {props.newMembershipName ? (
              <>
                por <strong>{props.newMembershipName}</strong>.
              </>
            ) : (
              <>por una nueva membresía.</>
            )}
          </p>
        )}

        <div className='risk-notice'>
          <ul>
            <li>
              Tu membresía actual será <strong>cancelada de inmediato</strong> al confirmar el
              cambio.
            </li>
            <li>
              La nueva membresía se <strong>cobrará de forma completa</strong>, según el plan y
              modalidad que selecciones a continuación.
            </li>
            <li>
              <strong>No se prorratea</strong> ni se descuenta el tiempo restante de tu membresía
              actual: ese tiempo no utilizado se pierde al confirmar el cambio.
            </li>
          </ul>
        </div>

        <p className='confirm-text'>¿Deseas continuar con el cambio de membresía?</p>

        <div className='container-buttons'>
          <button type='button' className='btn btn-cancel' onClick={props.onCancel}>
            No, mantener mi membresía
          </button>
          <button type='button' className='btn btn-confirm' onClick={props.onConfirm}>
            Sí, cambiar membresía
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MembershipChangeWarningModal;
